import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FlexLayoutModule } from "@angular/flex-layout";

import { AppRoutingModule } from '@app/app-routing.module';
import { BilMaterialModule } from '@app/shared/modules/bil-material.module';
import { HomeModule } from '@app/home/home.module';
import { RegistrationModule } from '@app/registration/registration.module';
import { NgOtpInputModule } from 'ng-otp-input';

import { AuthGuard } from '@core/services/auth/auth-guard-service.guard';

import { AppComponent } from '@app/app.component';
import { BilDesktopInterceptor } from '@core/interceptors/bil-desktop.interceptor';
import { BilSnackbarComponent } from '@core/components/bil-snackbar/bil-snackbar.component';
import { BilTermsConditionsComponent } from './shared/components/bil-terms-conditions/bil-terms-conditions.component';
import { ChangeDocumentAlertBoxComponent } from './shared/components/change-document-alert-box/change-document-alert-box.component';
import { BilAddPartnerDialogComponent } from './shared/components/bil-add-partner-dialog/bil-add-partner-dialog.component';
import { BilDashboardComponent } from './home/bil-dashboard/bil-dashboard.component';
import { BankStatementDialogComponent } from './shared/components/bil-bank-statement-dialog/bank-statement-dialog/bank-statement-dialog.component';
import { ReportViewModalComponent } from './shared/components/report-view-modal/report-view-modal.component';
import { CreditCardModalComponent } from './shared/modals/credit-card-modal/credit-card-modal.component';
import { PanCardModalComponent } from './shared/modals/pan-card-modal/pan-card-modal.component';
import { CocModalComponent } from './shared/modals/coc-modal/coc-modal.component';
import { MaoModalComponent } from './shared/modals/mao-modal/mao-modal.component';
import { AoaModalComponent } from './shared/modals/aoa-modal/aoa-modal.component';
import { AppDateAdapter } from './shared/components/date-formatter/date-formatter/date-formatter.component';
import { BilbilConvertToNumberPipe } from './shared/components/bil-convert-to-number.pipe.ts/convert-to-number/convert-to-number.component';
import { BureauTermConditionComponent } from './shared/components/bil-bureau-tnc-dialog/bureau-term-condition/bureau-term-condition.component';
import { BilDeleteItrComponent } from './shared/components/bil-delete-itr/bil-delete-itr.component';
import { WhiteListingDialogComponent } from './shared/components/bil-whitelist-dialog/white-listing-dialog/white-listing-dialog.component';
import { BilDocumetRequiredModalComponent } from './shared/components/bil-documet-required-modal/bil-documet-required-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    BilSnackbarComponent,
    BilTermsConditionsComponent,
    ChangeDocumentAlertBoxComponent,
    BilAddPartnerDialogComponent,
    BilDashboardComponent,
    BankStatementDialogComponent,
    ReportViewModalComponent,
    CreditCardModalComponent,
    PanCardModalComponent,
    CocModalComponent,
    MaoModalComponent,
    AoaModalComponent,
    AppDateAdapter,
    BilbilConvertToNumberPipe,
    BureauTermConditionComponent,
    BilDeleteItrComponent,
    WhiteListingDialogComponent,
    BilDocumetRequiredModalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BilMaterialModule,
    NgOtpInputModule,
    FlexLayoutModule
  ],
  entryComponents: [
    BilSnackbarComponent,
    ChangeDocumentAlertBoxComponent,
    BilAddPartnerDialogComponent,
    BankStatementDialogComponent,
    ReportViewModalComponent,
    CreditCardModalComponent,
    PanCardModalComponent,
    CocModalComponent,
    MaoModalComponent,
    AoaModalComponent,
    BureauTermConditionComponent,
    BilDeleteItrComponent,
    WhiteListingDialogComponent,
    BilDocumetRequiredModalComponent
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BilDesktopInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
